export function declineWord(count: number, wordSet: string[]) {
    const lastDigit = count % 10;
    const lastTwoDigits = count % 100;

    if (lastTwoDigits >= 11 && lastTwoDigits <= 14) {
        return `${count} ${wordSet[0]}`; // сделок
    } else if (lastDigit === 1) {
        return `${count} ${wordSet[1]}`; // сделка
    } else if (lastDigit >= 2 && lastDigit <= 4) {
        return `${count} ${wordSet[2]}`; // сделки
    } else {
        return `${count} ${wordSet[0]}`; //сделок
    }
}